import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const TrendingUp = ({
  className = "text-primary",
  viewBox = "0 0 44 45",
  width = 44,
  height = 45,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    fill="none"
  >
    <title>TrendingUp</title>
    <path
      d="M29.3317 11.666L33.53 15.8643L24.5834 24.811L17.25 17.4777L3.66504 31.081L6.25004 33.666L17.25 22.666L24.5834 29.9993L36.1334 18.4677L40.3317 22.666V11.666H29.3317Z"
      fill="currentColor"
    />
  </svg>
);
